import assert from 'assert';
import {getEnv} from '../../../common/env/env';
import {importKakaoSdk} from '../../../common/shared/login-pageweb/importKakaoSdk.function';
import {importSandboxKakaoSdk} from '../../../common/shared/login-pageweb/importSandboxKakaoSdk.function';
import {KakaoLoginError} from '../../../common/shared/login-pageweb/KakaoLoginError.class';
import {IS_CLIENT_SIDE} from '../../../common/shared/utils/constants';

export interface LoginHandlerParam {
  callbackUrl: string;
  relayPagePath: '/relay/oauth' | '/relay/login';
}

/**
 * Kakao SDK를 이용하여 카카오 로그인페이지로 이동합니다.
 */
export async function kakaoLogin({
  callbackUrl,
  relayPagePath,
}: LoginHandlerParam) {
  try {
    assert(IS_CLIENT_SIDE);
    if (getEnv().useSandboxKakao) {
      await importSandboxKakaoSdk();
    } else {
      await importKakaoSdk();
    }
    /**
     * https://developers.kakao.com/docs/latest/ko/kakaologin/js#login-info
     */
    (window as any).Kakao.Auth.authorize({
      redirectUri: `${window.location.origin}${relayPagePath}`,
      state: encodeURIComponent(callbackUrl),
      throughTalk: false,
    });
  } catch (error) {
    throw new KakaoLoginError({
      error: error.message || '알 수 없는 에러',
    });
  }
}
